import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { captureInstallPrompt } from './app/core/pwa/install-prompt';

// OPS-03-T01: the browser's install prompt can arrive before Angular bootstraps, so it is caught first.
captureInstallPrompt();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
